<template>
	<!-- 分享缩略图：必须是页面中靠前的真实图片(微信会忽略 display:none 的图)，故用移出可视区的方式隐藏 -->
	<img v-if="image" class="share-thumb" :src="image" alt="" />
</template>

<script>
// 微信分享卡片元信息(未接入 JS-SDK，走默认抓取)：
// - 标题：动态写 document.title
// - 描述：动态写 <meta name="description">
// - 图标：把目标图作为页面第一张图，提高微信抓取命中率
export default {
	name: 'ShareMeta',
	props: {
		title: { type: String, default: '' },
		description: { type: String, default: '' },
		image: { type: String, default: '' },
	},
	watch: {
		title() { this.apply() },
		description() { this.apply() },
	},
	created() { this.apply() },
	mounted() { this.apply() },
	methods: {
		apply() {
			if (this.title) document.title = this.title
			this.setDescription(this.description)
		},
		setDescription(content) {
			if (!content) return
			let el = document.querySelector('meta[name="description"]')
			if (!el) {
				el = document.createElement('meta')
				el.setAttribute('name', 'description')
				document.head.appendChild(el)
			}
			el.setAttribute('content', content)
		},
	},
}
</script>

<style scoped>
.share-thumb {
	position: absolute;
	left: -9999px;
	top: 0;
	width: 300px;
	height: 300px;
	pointer-events: none;
}
</style>
